import React from 'react'
import { Box, Chip, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { dsColorNew } from '@palette'
import { DS_REPRICING_ROUTES } from '@constants/routes'
import { toneChipSx } from 'Pages/DsRepricing/@components/tones'
import { launchedLine, passHref } from 'Pages/RealTimeHistory/RealTime/@services/enginePass'

// On the time stamp's line, after it (UX Obs. 11), on ONE line: the title, the time and the toolbar's
// icons stay where they are for every search (QA 2026-10-27). The pass's minute is the link, titled
// "See the pass in Executions" — the full sentence does not fit beside the time without wrapping the
// toolbar. Renders nothing for a search the engine did not launch. `pass` is fetched once by the
// table (`useEnginePass`): mui-datatables renders the title twice (toolbar and caption).
export default function EnginePassMark({ pass }) {
	if (!pass) return null
	return (
		<Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, whiteSpace: 'nowrap', fontSize: 12 }}>
			<Chip size="small" label="Repricing engine" sx={{ ...toneChipSx('info'), height: 20, fontSize: 11 }}/>
			<Box component="span" sx={{ color: dsColorNew.textMuted }}>
				{launchedLine(pass).replace(/ of .*$/, ' of')}{' '}
				<Link component={RouterLink} to={passHref(DS_REPRICING_ROUTES.EXECUTIONS_PATH, pass)}
				      title="See the pass in Executions" aria-label={`See the pass in Executions: ${launchedLine(pass)}`}
				      sx={{ fontSize: 'inherit', fontWeight: 600, color: dsColorNew.appBlue }}>
					{launchedLine(pass).replace(/^.* of /, '')}
				</Link>
			</Box>
		</Box>
	)
}
